module.exports = __webpack_public_path__ + "img/16_98.cf5cf398.png";